<div
  app-loading-content
  [height]="250"
  [loading]="loading === true"
>
  <div
    *ngIf="insights"
    class="bootstrap-insight-wcup"
  >
    <app-athlete-insights>
      <h2 class="insight insight__header">{{ insights.appearances }}</h2>
      <p class="insight uppertext-black insight__down category">{{ "appearances" | transloco }}</p>
    </app-athlete-insights>
    <app-athlete-insights>
      <h2 class="insight insight__header">{{ insights.podiums }}</h2>
      <p class="insight uppertext-black insight__down category">{{ "podiums" | transloco }}</p>
    </app-athlete-insights>
    <app-athlete-insights>
      <h2 class="insight insight__header">{{ insights.circuit_titles }}</h2>
      <p class="insight uppertext-black insight__down category">{{ "circuit_titles" | transloco }}</p>
    </app-athlete-insights>
  </div>

  <app-athlete-results-wcup-ranking-table
    *ngIf="($resultsGeneralProcessData | async)?.length > 0 && (wcup_athlete_service.categoriesReady.asObservable() | async)"
    [processDataDetail]="$resultsGeneralProcessData | async"
    [wCupName]="'Results'"
  ></app-athlete-results-wcup-ranking-table>
  <ng-container *ngFor="let result of model.data">
    <!-- Filter by id 12 -->
    <app-athlete-general-table-wcup-ranking-table
      *ngIf="12 === result.SubLevelId"
      [processDataDetail]="$resultsStage|async"
      [insights]="$insightsStage|async"
      [wCupName]="result.SubLevelName"
    ></app-athlete-general-table-wcup-ranking-table>
    <!-- Filter by id 13 -->
    <app-athlete-finals-table-wcup-ranking-table
      *ngIf="13 === result.SubLevelId"
      [processDataDetail]="$resultsFinal|async"
      [insights]="$insightsFinal|async"
      [wCupName]="result.SubLevelName"
    ></app-athlete-finals-table-wcup-ranking-table>
  </ng-container>
</div>
